import { DELETE_PROGRESS, END_DELETE, FILE_IS_DELETED, RELOAD_LIST, START_DELETE } from "../types"

export const startDeleteAction = (id) => ({
	type: START_DELETE,
	payload: id,
})

export const startBulkDeleteAction = (id) => ({
	type: START_DELETE,
	payload: id,
})

export const endDeleteAction = (id) => ({
	type: END_DELETE,
	payload: id,
})

export const endBulkDeleteAction = (id) => ({
	type: END_DELETE,
	payload: id,
})

export const DeleteProgressAction = (id, percentage) => ({
	type: DELETE_PROGRESS,
	payload: { id: id, percentage: percentage },
})

export const bulkDeleteProgressAction = (id, percentage) => ({
	type: DELETE_PROGRESS,
	payload: { id: id, percentage: percentage },
})

//the data is true/false
export const setIsFileDeleted = (data) => ({
	type: FILE_IS_DELETED,
	payload: data,
})

export const reloadList = (data) => ({
	type: RELOAD_LIST,
	payload: data,
})
